<template>
  <div>
    <nav class="level brand">
      <div class="level-left">
        <h1 class="level-item has-text-centered title is-1">
          <router-link class="site-title" :to="{name: 'home'}">Teaching Texas Slavery</router-link>
        </h1>
      </div>
    </nav>
    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="mainNav"
          v-on:click="showNav = !showNav"
          v-bind:class="{ 'is-active' : showNav }"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="mainNav" class="navbar-menu" v-bind:class="{ 'is-active' : showNav }">
        <div class="navbar-start">
          <router-link class="navbar-item" to="/narrative" aria-label="View the historical narrative">Narrative</router-link>
          <router-link class="navbar-item" to="/concepts" aria-label="Review concepts of race and racism">Concepts</router-link>
          <router-link class="navbar-item" to="/framework" aria-label="Review the pedagogical framework for teaching slavery">Framework</router-link>
          <router-link class="navbar-item" to="/documents" aria-label="Review primary source documents and records">Records &amp; Documents</router-link>
          <router-link class="navbar-item" to="/resources" aria-label="View additional resources on teaching slavery">Resources</router-link>
          <router-link class="navbar-item" to="/about" aria-label="Learn about this site">About</router-link>
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
              <router-link class="button is-danger" to="/workshops" aria-label="View information on workshops">
                <span>Workshops</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Nav",
  props: {
    msg: String
  },
  data: function() {
    return {
      showNav: false
    };
  }
};
</script>

<style scoped>
.site-title {
  margin-left: 10px;
}
</style>
